import { apiClient } from './client';
import type { LeaderboardEntry, Achievement, Badge } from '../types';

export async function fetchBadges(): Promise<Badge[]> {
  const { data } = await apiClient.get<Badge[]>('/gamification/badges');
  return data;
}

export async function syncTimezone(): Promise<void> {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (tz) await apiClient.put('/user/timezone', { timezone: tz });
}

export async function fetchLeaderboard(): Promise<LeaderboardEntry[]> {
  const { data } = await apiClient.get<LeaderboardEntry[]>('/leaderboard');
  return data;
}

export async function fetchAchievements(): Promise<Achievement[]> {
  const { data } = await apiClient.get<Achievement[]>('/user/achievements');
  return data;
}

export async function updateWeeklyGoal(days: number): Promise<void> {
  await apiClient.post('/user/goal', { weekly_goal_days: days });
}
